import type { FormatCurrencyOptions } from '@joyful/utils'
import { findLeafPrimitiveValue, formatCurrency } from '@joyful/utils'
import type { ReactElement } from 'react'
import { cloneElement, isValidElement } from 'react'

import { Copyable } from './Copyable'
import type { TabularProps } from './Tabular'
import { Tabular } from './Tabular'

interface BaseMoneyProps extends Omit<TabularProps, 'asChild' | 'children'> {
  formatOptions?: FormatCurrencyOptions
  /**
   * @default false
   */
  isCopyable?: boolean
}

export interface SimpleMoneyProps extends BaseMoneyProps {
  asChild?: false
  children: string | number | null | undefined
}

interface AsChildMoneyProps extends BaseMoneyProps {
  asChild: true
  children: ReactElement
}

export type MoneyProps = SimpleMoneyProps | AsChildMoneyProps

export function Money({
  asChild = false,
  children,
  formatOptions,
  isCopyable = false,
  ...props
}: MoneyProps) {
  const value = findLeafPrimitiveValue(children) ?? null
  const formattedValue =
    value === null ? '-' : formatCurrency(value, formatOptions)

  const money = (
    <Tabular {...props}>
      {asChild && isValidElement(children)
        ? // oxlint-disable-next-line react/no-clone-element
          cloneElement(children, undefined, formattedValue)
        : formattedValue}
    </Tabular>
  )

  return isCopyable === true ? (
    <Copyable asChild value={formattedValue}>
      {money}
    </Copyable>
  ) : (
    money
  )
}
